module.exports = __webpack_public_path__ + "img/cover_brown.193c61fc.png";